// This function is especially to access the price fields in the ecommerce tracking
// The prices in the ssc interfaces are often declared optional but always present when the tracking uses them
// But, the prices can be 0 and to avoid falsy errors we have to check with the 'nullish coalescence' operator than just with a 'not' operator
export function priceIfPresentOrZero(price: number | undefined): number {
  return price ?? 0;
}
